// Angular
import { Injectable } from '@angular/core';

// RxJS
import { Observable, Subject } from 'rxjs';

export interface IErrorsStateService {
  errorMessage$: Observable<string>;
  showError(error: string): void;
  longErrorMessage$: Observable<string>;
  showLongError(error: string): void;
}

@Injectable({
  providedIn: 'root'
})

export class ErrorsStateService implements IErrorsStateService {

  constructor() { }

  private error$$ = new Subject<string>();
  errorMessage$: Observable<string> = this.error$$.asObservable();

  private longError$$ = new Subject<string>();
  longErrorMessage$: Observable<string> = this.longError$$.asObservable();

  showError(error: string) {
    this.error$$.next(error);
  }

  /**
   * Raises an error that needs longer than the standard snackbar window to read,
   * such as a message listing several problems at once.
   */
  showLongError(error: string) {
    this.longError$$.next(error);
  }
}
